import { jsx as _jsx } from "react/jsx-runtime";
import { MapTo } from "@adobe/aem-react-editable-components";
import classNames from "classnames";
import { convertHeroData, useStringPlaceholder } from "@jti/loyalty";
import { useSelector } from "@jti/store";
import { HeroContentAuthoringWrapper, Loading } from "@jti/ui";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
import { processLoggedTitle } from "./util/processLoggedTitle";
export const heroV2EditConfig = {
    emptyLabel: "Hero V2",
    isEmpty: (props) => {
        if (!props || !props.content || !props.content.title)
            return true;
        if ((props.backgroundType === "image" && !props.desktopImage?.src) ||
            (props.backgroundType === "video" && !props.videoFileReference))
            return true;
        const { restrictedContent, restrictedTitle, restrictedText } = props.content;
        return !!(restrictedContent && (!restrictedTitle || !restrictedText));
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getProps: ({ cqPath, cqForceReload, appliedCssClassNames, aemNoDecoration, ...props }) => ({
        ...props,
    }),
};
export const HeroV2 = (props) => {
    const { isInEditor, ...otherProps } = props;
    const replaceStringPlaceholderRunner = useStringPlaceholder();
    const { isRestricted, points: { status }, } = useSelector((store) => store.loyaltyCore);
    const classes = classNames("loyalty__HeroV2", {
        "hero-banner-v2--authoring": isInEditor,
    });
    const { title, text, ctas } = convertHeroData(isRestricted, props);
    const { processedTitle, isLoading } = processLoggedTitle(status, replaceStringPlaceholderRunner, title);
    const newProps = {
        ...otherProps,
        content: {
            ...props.content,
            titleLogged: isLoading ? _jsx(Loading, { whiteDots: true }) : processedTitle,
            textLogged: text,
            cta: ctas,
        },
        isViewportHeight: false,
        isContainerWidth: true,
        removeVideoRoundedCorners: true,
    };
    return (_jsx("div", { className: classes, children: _jsx(HeroContentAuthoringWrapper, { data: newProps }) }));
};
export default MapTo("loyalty/components/heroV2")(withAemAuthoring(HeroV2, heroV2EditConfig));
